import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/franchiseDigitalMarketingData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const FranchiseDigitalMarketing = () => {
  useMetaTags({
    title: "Warrgyizmorsch: Franchise Digital Marketing Strategies That Work",
    description:
      "Drive growth with proven franchise digital marketing strategies by Warrgyizmorsch. Increase visibility, leads, and sales with expert online marketing solutions for franchises.",
    keywords:
      "franchise digital marketing, franchise digital marketing services, franchise online marketing, franchise digital marketing agency, digital marketing company franchise, digital agency franchise, digital advertising franchise",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Franchise Digital Marketing Strategies
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/franchiseMarketing.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  At Warrgyizmorsch we see that large scale franchise
                  enterprises require more than one size fits all marketing
                  plans. What we present is a custom, flexible and scalable
                  solution. We have franchise digital marketing which is built
                  out to see each individual location grow within the brand as a
                  whole. With us each franchise gets a custom approach that
                  brings local franchise digital marketing presence and global
                  reach together. From SEO to pay per click advertising, content
                  creation to email campaigns we use data which we analyze to
                  produce real results.
                </p>
              </div>
            </div>
            {/* Franchise Marketing Services Featured  */}
            <Handle_Largedata_section LargeData={LargeData} />
            {/* Why Your Business Requires Franchise Digital Marketing Services */}
            <Custom_section data={CustomSection} />
            {/* Why Work with Us for Franchise Digital Marketing Services?  */}
            <Assistance_section data={AssistanceSection} />
            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default FranchiseDigitalMarketing;
